import React, { useEffect } from 'react';

interface IProps {
  readonly total: number;
  readonly children: React.ReactNode;
  readonly onSelect: () => void;
  readonly onUp: () => void;
  readonly onDown: () => void;
}

export const Navigate = (props: IProps) => {
  const bindKeyboardEvent = () => {
    const fn = (e: any) => {
      const { keyCode } = e;
      if (keyCode === 13) {
        props.onSelect();
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      switch (keyCode) {
        // 上
        case 38:
          props.onUp();
          e.preventDefault();
          e.stopPropagation();
          break;
        // 下
        case 40:
          props.onDown();
          e.preventDefault();
          e.stopPropagation();
          break;
      }
    };
    window.addEventListener('keydown', fn, false);
    return () => {
      window.removeEventListener('keydown', fn, false);
    };
  };

  useEffect(() => {
    if (props.total) {
      return bindKeyboardEvent();
    }
  }, [props.total]);

  return <>{props.children}</>;
};
